import styled from '@emotion/styled';
import {
  colors,
  Modal as ModalBase,
  QuickActionGroup as QuickActionGroupBase,
  Button as ButtonBase,
  Stack,
  Typography,
} from '@ui-components/neo.tax';
import { ReactComponent as BuildingModern } from '@ui-components/neo.tax/dist/icons/building-modern.svg';
import { ReactComponent as CheckCircle } from '@ui-components/neo.tax/dist/icons/check-circle-1.svg';
import { ReactComponent as Check } from '@ui-components/neo.tax/src/assets/icons/check.svg';

export const Button = styled(ButtonBase, {
  shouldForwardProp: (prop) => !['completed'].includes(prop),
})(({ completed = false, disabled = false }) => ({
  color: disabled ? colors.gray[400] : completed ? colors.gray[700] : colors.primary[600],
  ':disabled': {
    opacity: 1,
    backgroundColor: colors.gray[200],
  },
}));

export const BuildingModernIcon = styled(BuildingModern)({
  width: 48,
  color: colors.blue[600],
});

export const CheckIcon = styled(Check)({
  width: 24,
  color: colors.white,
});

export const StyledSpan = styled.span({
  display: 'block',
});

export const CheckCircleIcon = styled(CheckCircle)({
  width: 20,
  color: colors.gray[400],
});

export const Modal = styled(ModalBase)({
  maxWidth: '765px',
  width: '100%',
});

export const QuickActionGroup = styled(QuickActionGroupBase)({
  borderTop: `1px solid ${colors.gray[200]}`,
  padding: '1.25rem 0',
});

export const HeroContainer = styled(Stack)({
  backgroundColor: colors.blue[700],
  borderRadius: '6px',
  minHeight: 284,
});

export const SkipAutoConnect = styled(Typography)({
  position: 'absolute',
  top: 8,
  right: 12,
});
